






























import { Prop, Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
@Component
export default class LoginForm extends Vue {
	@Prop ({
		type: Boolean,
		default: true
	}) private logoFlag!: boolean
	private ruleForm: {
		phone: string | undefined
	} = {
		phone: ''
	}
	private rules: object = {
		phone: [{ validator: this.validatePhone, trigger: 'blur' }]
	}
	private validatePhone (rule: any, value: any, callback: any): void {
		if (!value) {
			callback(new Error('手机号码不能为空'))
		} else if (!(this as any).$fxUtils.regPhone().test(value)) {
			callback(new Error('手机号码格式不正确'))
		} else {
			callback()
		}
	}
	private onSubmitPhoneClick (ruleForm: string): void {
		(this.$refs[ruleForm] as any).validate().then((valid: any) => {
			this.$emit('on-submitPhone', this.ruleForm.phone)
		})
	}
	private onCellInputEnter (arg: any, prop: string): void {
		if (prop === 'submit') {
			this.onSubmitPhoneClick('ruleForm')
		} else {
			(this.$refs[prop] as any).focus()
		}
	}
	private onLoginClick (): void {
		this.$emit('on-login-click')
	}
	private onRegisterClick (): void {
		this.$emit('on-register-click')
	}
}
